<template>
  <div class="enrolling-admission-line-title">
    <span class="title">{{title}}</span>
    <span class="title">{{quotaTitle}}：<span class="success-text">{{quota}}</span>人</span>
    <span class="title">剩余额度：<span class="warning-text">{{leftNum}}</span>人</span>
  </div>
</template>

<script>
import globalEvent from '../../../../../../../constants/globalEvent'
import routeConfig from '../../../../../../../constants/routeConfig'

export default {
  name: 'EnrollingAdmissionLineTitle',
  props: {
    title: String
  },
  data () {
    return {
      quota: null,
      leftNum: null,
      admissionStageCode: null
    }
  },
  computed: {
    quotaTitle () {
      switch (String(this.admissionStageCode)) {
        case '1':
          return '线上生录取额度'
        case '2':
          return '总录取额度'
        default:
          return '录取额度'
      }
    }
  },
  methods: {
    queryEnrollQuota () {
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/scoreLineStudent/queryEnrollQuota',
        method: 'post',
        data: this.$qs.stringify({
          site: this.$attrs.site,
          studentType: this.$attrs.studentType
        })
      }).then(response => {
        let data = response.data
        if (data) {
          switch (data['responseCode']) {
            case 'SUCCESS': {
              this.admissionStageCode = data['admissionStageCode']
              this.quota = data['quota'] === null || data['quota'] === undefined ? '-' : data['quota']
              if (this.quota === '-') {
                this.leftNum = '-'
              } else {
                this.leftNum = this.quota - (data['admitNum'] || 0)
              }
              break
            }
            default: {
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      })
    },
    bindEvent () {
      this.$bus.$on(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${this.$attrs[routeConfig.DataGrid.param]}`, this.queryEnrollQuota)
    },
    unbindEvent () {
      this.$bus.$off(`${globalEvent.templateGrid.DATA_STATE_CHANGED}:${this.$attrs[routeConfig.DataGrid.param]}`, this.queryEnrollQuota)
    }
  },
  mounted () {
    this.bindEvent()
    this.queryEnrollQuota()
  },
  beforeDestroy () {
    this.unbindEvent()
  },
  activated () {
    this.queryEnrollQuota()
  }
}
</script>

<style lang="scss">
@import '../../../../../../../styles/color';
.enrolling-admission-line-title {
  .title {
    margin-right: 20px;
  }
  .success-text {
    color: $set-primary-color;
  }
  .warning-text {
    color: $set-warning-color;
  }
}
</style>
